import React from "react";
import { ChevronDownIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { faqs } from "../../data/content";
export function Faq() {
  return <section className="bg-white px-4 py-14 sm:py-20" data-id="element-165" data-mp="x3jud2iyjg5s">
      <div className="mx-auto max-w-3xl" data-id="element-166" data-mp="x4ttlv1jque0">
        <h2 className="text-center font-display text-[28px] font-extrabold leading-tight text-plum-950 sm:text-4xl" data-id="element-167" data-mp="122n0kqaobsfc">
          Frequently Asked Questions
        </h2>
        <div className="mt-8 space-y-3" data-id="element-168" data-mp="1pspnkrzqe873">
          {faqs.map(f => <details key={f.q} className="group rounded-2xl bg-plum-50 px-5 py-4 open:bg-plum-100" data-id="element-169" data-mp="1uq927t0ccmzk">
              <summary className="flex cursor-pointer list-none items-center justify-between gap-4 font-display text-base font-extrabold text-plum-950 [&::-webkit-details-marker]:hidden" data-id="element-170" data-mp="1g1d00ckyu46v">
                {f.q}
                <ChevronDownIcon className="h-5 w-5 shrink-0 text-plum-600 transition-transform duration-200 ease-out group-open:rotate-180" aria-hidden="true" data-id="element-171" data-mp="28qa5tg7zq8iq" />
              </summary>
              <p className="mt-3 text-[15px] leading-relaxed text-slate-700" data-id="element-172" data-mp="2onw39q64v2p5">{f.a}</p>
            </details>)}
        </div>
        <div className="mt-10" data-id="element-173" data-mp="2ygjwyc1tgqjn">
          <CtaButton label="All Clear — I’m Ready to Start" sub="Get the 11-resource collection for $27" data-id="element-174" data-mp="2yhlcotts217p" />
        </div>
      </div>
    </section>;
}